<template>
  <div class="LocationSelector">
    <select v-on:change="handleSelectionChange">
      <option selected disabled value="">Choose a location</option>

      <optgroup label="Most Popular">
        <option data-location="53.299326,-6.164434">Seapoint</option>
        <option data-location="53.35443,-6.170753">Dollymount</option>
        <option data-location="53.268992,-6.097531">Vico</option>
        <option data-location="52.937331,-9.354528">Lahinch</option>
        <option data-location="53.256505,-9.090429">Salthill (Galway)</option>
        <option data-location="54.263458,-8.621671">Rosses Point</option>
      </optgroup>

      <optgroup v-for="(region, index) in locations" :key="region" v-bind:label="index">
        <option v-for="(place, index) in region" :key="place" v-bind:data-location="place"> {{index}} </option>
      </optgroup>
    </select>
  </div>
</template>

<script>

import locations from '../locations.json';

export default {
    name: 'LocationSelector',
    props: {
      method: { type: Function },
    },
    methods: {
      handleSelectionChange: function (event) {
        // Instead of calling the method we emit an event
        let name = event.target.value;
        let newLoc = event.target.selectedOptions[0].dataset.location;
        newLoc = newLoc.split(',');
        
        let updatedLocationObject = {
          name, 
          latlng: newLoc
        }
        
        this.$emit('update-location', updatedLocationObject);
        }
      },
      data () {
        return {
          locations,
        }
      }
  }
</script>

<style lang="scss">
.LocationSelector{
  display: flex;
  // justify-content: center;
  // align-items: center;
  width: 100%;
  
  select{
    font-family: 'Poppins', sans-serif;
    border: none;
    outline: none;
   
    margin-left: 20px;
    border-radius: 6px;
    background-color: var(--text-secondary);
    color: var(--mid-grey);
    font-size: 16px;
    padding: 16px;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;

    ::-ms-expand {
      //display: none;
    }

    border:none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -ms-appearance: none; /* get rid of default appearance for IE8, 9 and 10*/
  }
}
</style>

